import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  UserWalletManageService,
  CreateMultipleUserDto,
  CreateMultipleUserEntity,
} from 'services/openapi';

export const useCreateMultiUserMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<CreateMultipleUserEntity, Error, CreateMultipleUserDto>({
      mutationFn: (variables: CreateMultipleUserDto) => {
        return UserWalletManageService.userManageControllerCreateMultiUser(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
